/*
 * Copyright (c) Volvo Group. All rights reserved.
 * SPDX-License-Identifier: ISC
 */

import { configureStore } from "@reduxjs/toolkit";
import notificationReducer from "../core/Notifications/store/NotificationSlice";
import navigationBarReducer from "../core/Layout/store/NavigationBarSlice";

export const store = configureStore({
  reducer: {
    notifications: notificationReducer,
    navigationBar: navigationBarReducer,
  },
});
